<template>
	<div class="meidum-b">
		<div class="meidum-b-title">
			一起见证<br>中概的成长之路
		</div>
		<!-- <div class="meidumz">
			<div class="ry-cc">
				<div class="ry-b">
					
				</div>

				<el-carousel :interval="0" arrow="always" indicator-position="none">
					<el-carousel-item v-for="item in list" :key="item">
						<div class="ry-b-c">
							<div class="ry-b-c-item" v-for="item1 in item" style="" @click="tapDetails(item1)">
								<div class="t">{{item1.createTime.substring(0, 10)}}</div>
								<div class="s11">{{item1.barticleTile}}</div>
								<img class="item-h" :src="item1.barticleUrl" alt="">
							</div>
						</div>
					</el-carousel-item>
					
				</el-carousel>
			</div>
		</div> -->
		
		<!-- <div class="medium-cc">
			<div class="medium-c1">
				<div class="medium-c-item" v-for="(item, index) in list" :key="index">
					<div class="medium-c-item-l">
						<div class="medium-c-item-l-top">
							{{item.createTime.substring(0, 4)}} 
						</div>
						<div v-if="list.length-1 != index" class="medium-c-item-l-bottom"></div>
					</div>
					<div class="medium-c-item-b">
						
					</div>
					<div class="medium-c-item-r">
						<div class="medium-c-item-r-r">
							<div class="medium-c-item-r-r-top">
								{{item.barticleTile}}
							</div>
							<div class="medium-c-item-r-r-top1">
								{{item.createTime.split('00:00:00')[0]}}
							</div>
							<div class="medium-c-item-r-r-bottom">
								{{item.content1}}
							</div>
							
						</div>
						<img class="medium-c-item-r-l" :src="item.barticleUrl" alt="" />
					</div>
				</div>
			</div>
		</div> -->
		<div class="medium-cc new-medium-cc">
			<div class="medium-c1">
				<div class="medium-c-item" v-for="(item, index) in dashijiList" :key="index">
					<div class="medium-c-item-l">
						<div class="medium-c-item-l-top">
							{{item.time}} 
						</div>
						<div v-if="dashijiList.length-1 != index" class="medium-c-item-l-bottom"></div>
					</div>
					<div class="medium-c-item-b">
						
					</div>
					<div class="medium-c-item-r">
						<div class="mobile-medium-cir-title">{{item.time}} </div>
						<div class="medium-c-item-r-r new-medium-c-item-r-r">
							<!-- <div class="medium-c-item-r-r-top">
								{{item.barticleTile}}
							</div>
							<div class="medium-c-item-r-r-top1">
								{{item.createTime.split('00:00:00')[0]}}
							</div>
							<div class="medium-c-item-r-r-bottom">
								{{item.content1}}
							</div> -->
							<div class="about1-info-box-s-s" v-for="(subitem, subindex) in dashijiList[index].subjects"
								:key="subindex">
								<div class="about1-info-box-s-s-yuan"></div>
								<div class="about1-info-box-s-s-sec">{{subitem}}</div>
							</div>
						</div>
						<!-- <img class="medium-c-item-r-l" :src="item.barticleUrl" alt="" /> -->
					</div>
				</div>
			</div>
		</div>
		




	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default: []
			},


		},
		data() {
			return {
				selectIndex: 0,
				dashijiList:[{
					time:'2025',
					subjects:[
						'中概电力工程有限公司更名为浙江中概电力科技有限浙江公司'
					]
				},{
					time:'2024',
					subjects:[
						'“定战略，调机构、夯基础、谋发展”战略调整年，确立三大业务、五大板块战略，成立电力事业部与运维事业部；',
						'与江苏悦达、中车、广东建工、东方雨虹建立战略合作关系；',
						'承接上海松江高铁站配电项目、台州国家博览中心6MW光伏项目；',
						'承接汾口宋京油茶40WM农光互补项目EPC工程。'
					]
				},{
					time:'2023',
					subjects:[
						'通过SA8000社会责任体系认证；',
						'荣获拱墅区经济贡献优秀奖；',
						'与杭泰、华电浙江公司建立战略合作关系；','订单业务实现跨越式突破，EPC业务年装机容量超百兆瓦；',
						'首次承接百米高楼光伏项目及首次创新应用钙钛矿组件（余杭区政府1.2MW光伏电站）；',
						'首次在隧道创新应用柔性组件光伏项目（运溪隧道236.25kWp光伏项目）。'
					]
				},{
					time:'2022',
					subjects:[
						'荣获国家科技型中小企业称号；',
						'信息化平台建设包括：工程宝、供应链、金蝶系统上线；',
						'承接杭汽轮12MW屋顶分布式光伏发电项目；',
						'承接广东双林生物有限公司10kV配电项目。'
					]
				},{
					time:'2021',
					subjects:[
						'与江苏天电、正泰集团建立战略合作关系；',
						'承接承德县“十三五”第二批村级光伏扶贫电站项目。'
					]
				},{
					time:'2020',
					subjects:[
						'与凯达、远景建立战略合作关系；',
						'承接甬台温高速公路复线温州瑞安至苍南（浙闽界）段公路变配电安装工程。'
					]
				},{
					time:'2019',
					subjects:[
						'顺利通过ISO9000、ISO14000体系认证，内部管理逐步提升；',
						'与富春江集团签订战略合作协议，承接永特信息、永特电缆5.3872MW光伏项目。'
					]
				},{
					time:'2018',
					subjects:[
						'杭州中概电力工程有限公司更名为浙江中概电力工程有限公司；',
						'进入大有电力系统白名单，承接镇中变110变电站业务；',
						'建成并自持各类光伏电站累计超200MW， 同时进入EPC领域。'
					]
				},{
					time:'2017',
					subjects:[
						'攻克行业内多项技术难题，为世界五百强中大元通物流园完成首个6MW BIPV分布式光伏项目建设，该项目被列入杭州市创新案列，被市光伏协会、国家能源等专家列为示范项目，多次迎接各类专家参观学习；',
						'实现分布式光伏项目装机容量累计达100MW，分别建设了嘉士工业园4.5MW、台州华迪5.5MW、奥利达电梯4.7MW等大型分布式光伏项目。'
					]
				},{
					time:'2016',
					subjects:[
						'更名为杭州中概电力工程有限公司；',
						'正式进入分布式光伏行业，首次承接杭州帷盛科技1MW分布式光伏业务。'
					]
				},{
					time:'2015',
					subjects:[
						'杭州中概装饰工程有限公司成立。'
					]
				}]
			}
		},
		created() {

		},
		methods: {
			// customArrow(type) {
			// 	console.log(type, "00000")
			//     if (type === 'prev') {
			//       return `<button class="custom-arrow prev">上一张111</button>`;
			//     } else if (type === 'next') {
			//       return `<button class="custom-arrow next">下一张</button>`;
			//     }
			//     return '';
			//   },
			tapList(index) {
				this.selectIndex = index
			},
			tapDetails(item) {
				this.$router.push({
					path: "/mediumdetails",
					query: {
						id: item.bid
					}
				})
			}

		}
	}
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}
	
	.mobile-medium-cir-title{
		display: none;
	}
	
	.about1-info-box-s-s {
		// width: 50%;
		width:100%;
		font-size: 20px;
		line-height: 23px;
		margin-bottom: 16px;
		position:relative;
		.about1-info-box-s-s-yuan {
			width: 10px;
			height: 10px;
			border-radius: 5px;
			margin-right: 10px;
			display: inline-block;
			position:absolute;
			top:11px;
			background-color: #22A3D3;
		}
	
		.about1-info-box-s-s-sec {
			padding-left:20px;
			line-height: 30px;
			width: calc(100% - 20px);
			display: inline-block;
		}
	}
	
	.medium-c {
		width: 100%;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		.medium-c1 {
			
			.medium-c-item {
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				// align-items: center;
				// padding-bottom: 60px;
				.medium-c-item-l {
					flex-direction: column;
					justify-content: flex-start;
					align-items: center;
					.medium-c-item-l-top {
						width: 100%;
						background-color: #22A3D3;
						text-align: center;
						color: white;
					}
					.medium-c-item-l-bottom {
						width: 1px;
						background-color: #22A3D3;
					}
					
				}
				.medium-c-item-b {
					height: 1px;
					background-color: #22A3D3;
				}
				.medium-c-item-r {
					background-color: rgba(34, 163, 211, 0.05);
					background-color: aliceblue;
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					.medium-c-item-r-r {
						width:100%;
						.medium-c-item-r-r-top {
							font-family: AlibabaPuHuiTi-Medium;
							font-weight: 500;
							color: #333333;
						}
						
						
						.medium-c-item-r-r-bottom {
							font-family: AlibabaPuHuiTi-Regular;
							font-weight: 400;
							color: #333333;
							display: -webkit-box;
							    -webkit-box-orient: vertical;
							    -webkit-line-clamp: 5;
							    overflow: hidden;
						}
						
					}
					img {

					}
					
				}
				
			}
			
		}
	}
	
	@media screen and (min-width: 1200px) {
		.meidum-b-title{
			width:1200px;
			margin:0 auto;
			padding-top:40px;
			font-size:24px;
			line-height:34px;
		}
		.medium-cc {
			width: 100%;
			padding: 80px 0;
			.medium-c1 {
				width: 1200px;
				
				.medium-c-item {
					width: 1200px;
					.medium-c-item-l {
						display: flex;
						width: 150px;
						.medium-c-item-l-top {
							width: 100%;
							height: 60px;
							line-height: 60px;
							font-size: 24px;
						}
						.medium-c-item-l-bottom {
							width: 1px;
							height: calc(100% - 60px);
						}
						
					}
					.medium-c-item-b {
						width: 72px;
						margin-top: 30px;
					}
					.medium-c-item-r {
						// width: calc(100% - 225px);
						width:100%;
						// height: 260px;
						padding: 30px 45px;
						margin-bottom: 30px;
						.medium-c-item-r-r {
							
							.medium-c-item-r-r-top {
								font-size: 20px;
							}
							.medium-c-item-r-r-top1 {
								margin-top: 12px;
								font-size: 16px;
							}
							
							.medium-c-item-r-r-bottom {
								margin-top: 20px;
								font-size: 20px;
							}
							
						}
						img {
							width: 300px;
							height: 200px;
							object-fit: cover;
						}
						
					}
					
				}
				
			}
		}
	}
	@media screen and (max-width: 1200px) {
		.meidum-b-title{
			padding-top:30px;
			font-size:20px;
			line-height:34px;
		}
		.medium-cc {
			width: 100%;
			padding: 60px 0;
			.medium-c1 {
				width: 100%;
				
				.medium-c-item {
					width: 100%;
					.medium-c-item-l {
						display: flex;
						width: 120px;
						.medium-c-item-l-top {
							width: 100%;
							height: 50px;
							line-height: 50px;
							font-size: 20px;
						}
						.medium-c-item-l-bottom {
							width: 1px;
							height: calc(100% - 50px);
						}
						
					}
					.medium-c-item-b {
						width: 60px;
						margin-top: 25px;
					}
					.medium-c-item-r {
						width: calc(100% - 180px);
						// height: 230px;
						padding: 20px 32px;
						margin-bottom: 20px;
						.medium-c-item-r-r {
							
							.medium-c-item-r-r-top {
								font-size: 18px;
							}
							
							.medium-c-item-r-r-top1 {
								margin-top: 15px;
								font-size: 14px;
							}
							
							.medium-c-item-r-r-bottom {
								margin-top: 18px;
								font-size: 18px;
							}
							
						}
						img {
							width: 240px;
							height: 160px;
						}
						
					}
					
				}
				
			}
		}
	}
	@media screen and (max-width: 880px) {
		.meidum-b{
			min-height:calc(100vh - 540px);
		}
		.meidum-b-title{
			padding-left:20px;
			font-size:18px;
		}
		.medium-cc {
			width: 100%;
			padding: 60px 0;
			&.new-medium-cc{
				padding-top:30px;
			}
			.medium-c1 {
				width: 100%;
				
				.medium-c-item {
					width: 100%;
					margin-bottom: 10px;
					.medium-c-item-l {
						display: none;
						
					}
					.medium-c-item-b {
						display: none;
					}
					.medium-c-item-r {
						width: calc(100% - 20px);
						// height: 140px;
						margin-left: 10px;
						padding: 12px 16px;
						
						.mobile-medium-cir-title{
							display: block;
							position:absolute;
							font-size:16px;
							color:#22A3D3;
						}
						.medium-c-item-r-r {
							width: 70%;
							// width:100%;
							&.new-medium-c-item-r-r{
								width:100%;
								padding-top:30px;
								.about1-info-box-s-s-sec{
									font-size:14px;
								}
							}
							.medium-c-item-r-r-top {
								font-size: 15px;
							}
							.medium-c-item-r-r-top1 {
								margin-top: 10px;
								font-size: 12px;
							}
							
							.medium-c-item-r-r-bottom {
								margin-top: 12px;
								font-size: 15px;
							}
							
						}
						img {
							width: 30%;
							height: 80%;
						}
						
					}
					
				}
				
			}
		}
	}

	// .meidumz {
	// 	background-color: #fff;
	// 	flex-direction: column;
	// 	align-items: center;
	// 	box-sizing: border-box;

	// 	.ry-cc {}

	// 	// .ry-b {

	// 	// 	align-items: center;

	// 	// 	.ry-b-l,
	// 	// 	.ry-b-r {
	// 	// 		cursor: pointer;

	// 	// 	}





	// 	.ry-b-c {

	// 		box-sizing: border-box;
	// 		align-items: center;
	// 		display: flex;
	// 		justify-content: space-between;
	// 		align-items: center;

	// 		.ry-b-c-item {
	// 			 transition: transform 0.3s;
	// 			flex-direction: column;
	// 			align-items: center;
	// 			text-align: left;  
	// 			background-color: #22A3D3;
	// 			display: flex;
	// 			flex-direction: column;
	// 			align-items: center;
	// 			text-align: left;
	// 			color: white;
	// 			box-sizing: border-box;

	// 			color: white;

	// 			.item-h {}

	// 			.t {
	// 				text-align: left;
	// 			}

	// 			.s11 {
	// 				text-align: left;
	// 				opacity: 0.85;
	// 			}
	// 		}
	// 		.ry-b-c-item:hover {
 //       transition: width 0.3s, height 0.3s;
 //       transform: scale(0.95);
       
 //      }

	// 	}

	// 	// }
	// }

	// @media screen and (min-width: 1200px) {
	// 	.meidumz {
	// 		width: 100%;
	// 		display: flex;
	// 		flex-direction: column;
	// 		justify-content: center;
	// 		padding-bottom: 80px;
	// 		padding-top: 80px;

	// 		.ry-cc {
	// 			width: 1320px;
	// 		}

	// 		// .ry-b {
	// 		// 	width: 100%;
	// 		// 	display: flex;
	// 		// 	justify-content: space-between;
	// 		// 	.ry-b-l,
	// 		// 	.ry-b-r {
	// 		// 		width: 50px;
	// 		// 		height: 50px;
	// 		// 	}
	// 		.ry-b-c {
	// 			width: 100%;
	// 			padding: 0 60px;
	// 			box-sizing: border-box;
	// 			display: flex;
	// 			justify-content: flex-start;

	// 			.ry-b-c-item {

	// 				width: calc(25% - 6px);
	// 				height: 350px;
	// 				border-radius: 5px;
	// 				background-color: #22A3D3;
	// 				margin: 0 8px;
	// 				display: flex;
	// 				flex-direction: column;
	// 				align-items: center;
	// 				text-align: left;
	// 				color: white;
	// 				padding: 30px 20px;
	// 				box-sizing: border-box;

	// 				.item-h {
	// 					width: 100%;
	// 					height: 160px;
	// 					margin-top: 30px;
	// 				}

	// 				.t {
	// 					width: 100%;
	// 					font-size: 16px;
	// 				}

	// 				.s11 {
	// 					width: 100%;
	// 					margin-top: 8px;
	// 					margin-top: 12px;
	// 					font-size: 14px;
	// 				}
	// 			}
	// 		}

	// 		// }
	// 	}

	// }

	// @media screen and (max-width: 1200px) {
	// 	.meidumz {
	// 		width: 100%;
	// 		display: flex;
	// 		flex-direction: column;
	// 		justify-content: center;
	// 		padding-bottom: 80px;
	// 		padding-top: 80px;

	// 		.ry-cc {
	// 			width: 100%;
	// 		}

	// 		// .ry-b {
	// 		// 	width: 100%;
	// 		// 	display: flex;
	// 		// 	justify-content: space-between;
	// 		// 	.ry-b-l,
	// 		// 	.ry-b-r {
	// 		// 		width: 40px;
	// 		// 		height: 40px;
	// 		// 	}
	// 		.ry-b-c {
	// 			width: 100%;
	// 			padding: 0 60px;
	// 			box-sizing: border-box;
	// 			display: flex;
	// 			justify-content: space-between;

	// 			.ry-b-c-item {
	// 				width: calc(50% - 9px);
	// 				height: 240px;
	// 				border-radius: 5px;
	// 				background-color: #39A6A7;
	// 				margin: 0 8px;
	// 				display: flex;
	// 				flex-direction: column;
	// 				align-items: center;
	// 				text-align: left;
	// 				color: white;
	// 				padding: 20px 20px;
	// 				box-sizing: border-box;

	// 				.item-h {
	// 					width: 100%;
	// 					height: 100px;
	// 					margin-top: 30px;
	// 				}

	// 				.t {
	// 					width: 100%;
	// 					font-size: 16px;
	// 				}

	// 				.s11 {
	// 					width: 100%;
	// 					margin-top: 8px;
	// 					margin-top: 12px;
	// 					font-size: 14px;
	// 				}
	// 			}
	// 		}

	// 		// }
	// 	}
	// }

	// @media screen and (max-width: 880px) {
	// 	.meidumz {
	// 		width: 100%;
	// 		display: flex;
	// 		flex-direction: column;
	// 		justify-content: center;
	// 		padding-bottom: 50px;
	// 		padding-top: 50px;

	// 		.ry-cc {
	// 			width: 100%;
	// 		}

	// 		// .ry-b {
	// 		// 	width: 100%;
	// 		// 	display: flex;
	// 		// 	justify-content: space-between;
	// 		// 	.ry-b-l,
	// 		// 	.ry-b-r {
	// 		// 		display: none;
	// 		// 	}
	// 		.ry-b-c {
	// 			width: 100%;
	// 			padding: 0 50px;
	// 			box-sizing: border-box;
	// 			display: flex;
	// 			justify-content: space-between;

	// 			.ry-b-c-item {
	// 				width: 100%;
	// 				height: 280px;
	// 				border-radius: 5px;
	// 				background-color: #39A6A7;
	// 				margin: 0 8px;
	// 				display: flex;
	// 				flex-direction: column;
	// 				align-items: center;
	// 				text-align: left;
	// 				color: white;
	// 				padding: 20px 20px;
	// 				box-sizing: border-box;

	// 				.item-h {
	// 					width: 100%;
	// 					height: 120px;
	// 					margin-top: 10px;
	// 				}

	// 				.t {
	// 					width: 100%;
	// 					font-size: 15px;
	// 				}

	// 				.s11 {
	// 					width: 100%;
	// 					margin-top: 8px;
	// 					font-size: 14px;
	// 				}
	// 			}
	// 		}

	// 		// }
	// 	}
	// }
</style>